import { createUseStyles } from '@pe-libs/react-components/build/theme';

const useStyles = createUseStyles(
  'expert-directory-no-results-page',
  ({ breakpoints: { up }, palette: { common } }) => ({
    container: {
      '& .searchSectionModifier': {
        textShadow: 'none',
        paddingTop: '11rem',
        [up('sm')]: {
          paddingTop: '13.5rem',
        },
      },
      '& .descriptionText': {
        marginTop: '0.5rem',
        [up('sm')]: {
          fontSize: '1.125rem',
        },
      },
      '& .linkPadding': {
        paddingTop: '1rem',
      },
    },
    link: {
      color: common.white,
    },
    sectionArticle: {
      '& .redirectionCta': {
        display: 'none',
      },
    },
    sectionIndustryCatalogue: {
      '& .industryCatalogueSearch': {
        display: 'none',
      },
    },
  }),
);

export default useStyles;
